import axios from 'axios';
import { format, parseISO } from 'date-fns';

/* eslint no-param-reassign: ["error"] */
const currentState = {
  availableDates: [],
  availableDatesByDate: [],
};

const mutations = {
  set_available_dates(state, { availableDates }) {
    state.availableDates = availableDates;
  },
  set_available_dates_by_date(state, { availableDatesByDate }) {
    state.availableDatesByDate = availableDatesByDate;
  },
};

const actions = {
  async getAvailableDates({ commit }) {
    try {
      const { data } = await axios.get(`${process.env.VUE_APP_API_URL}/bookings/dates`);
      commit('set_available_dates', { availableDates: data.availableDates });
      commit('set_available_dates_by_date', { availableDatesByDate: data.availableDatesByDate });
    } catch ({ response }) {
      console.log(response);
    }
  },
};

const getters = {
  availableDates: state => state.availableDates,
  availableDatesByDate: state => Object.entries(state.availableDatesByDate).reverse(),
  calendarDates: state => state.availableDates.map(date => ({
    key: date.id,
    dates: parseISO(date.starts_at),
    customData: {
      id: date.id,
      title: `<strong>${format(parseISO(date.starts_at), 'HH:mm')}</strong> ${
        date.product_info.name
      } (${date.bookings.length} av ${date.participants})`,
      class: 'bg-primary text-white',
    },
  })),
};

export default {
  namespaced: true,
  state: currentState,
  getters,
  actions,
  mutations,
};
